module.exports = __webpack_public_path__ + "img/Lei Icon - charcoal.4ba1234a.svg";